<template>
  <div>
    <div
      class="wrap-tooltip"
      @mouseleave="isShowPopup = false"
    >
      <!-- Icon -->
      <img
        :src="require('@/assets/icon/help.svg')"
        :width="width"
        alt="type-help"
        @click="isShowPopup = true"
        @mouseover="isShowPopup = true"
      >

      <!-- Tooltip Popup -->
      <div
        v-if="isShowPopup"
        :class="position"
        class="tooltip-popup"
      >
        <div
          v-if="custom"
          v-html="description"/>
        <p
          v-else
          class="description">{{ description }}</p>
        <a
          v-if="url"
          :href="url">More Detail</a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-console, no-unused-vars */

export default {
  props: {
    description: {
      type: String,
      default: () => '',
    },
    url: {
      type: String,
      default: () => '',
    },
    width: {
      type: String,
      default: () => '10',
    },
    position: {
      type: String,
      default: () => 'right',
    },
    custom: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      isShowPopup: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrap-tooltip {
    position: relative;

    .tooltip-popup {
      width: max-content;
      min-width: 134px;
      max-width: 300px;
      position: absolute;
      top: 27px;
      background-color: white;
      padding: 8px;
      border-radius: 8px;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      z-index: 1;

      p, a {
        font-size: 12px;
      }

      p {
        color: $black-sample;
        line-height: 12px;
        margin-bottom: 0;
      }
      a {
        color: $primary-sample;
        text-decoration: none;
      }
    }

    .tooltip-popup.right {
      left: 0;
    }

    .tooltip-popup.left {
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tooltip/jTooltipCreateView.vue